import { LegalShell, LegalSection } from "./LegalShell";

export default function Datenschutz() {
  return (
    <LegalShell title="Datenschutzerklärung">
      <LegalSection heading="1. Datenschutz auf einen Blick">
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Nachfolgend
          informieren wir Sie über die Verarbeitung personenbezogener Daten bei der Nutzung
          unserer Website.
        </p>
      </LegalSection>
      <LegalSection heading="2. Verantwortlicher">
        <p className="font-semibold text-[#0A0A0A]">SA Webdesign</p>
        <p>Inhaber: Stephan Appenzeller</p>
        <p>Bahnstraße 19<br />40878 Ratingen</p>
        <p>
          Telefon: <a href="tel:+4916094869112" className="text-[#2563EB] hover:underline">0160 94869112</a>
          <br />
          E-Mail: <a href="mailto:stephan@sa-webdesign.net" className="text-[#2563EB] hover:underline">stephan@sa-webdesign.net</a>
          <br />
          Website: <a href="https://www.sa-webdesign.net" className="text-[#2563EB] hover:underline">https://www.sa-webdesign.net</a>
        </p>
      </LegalSection>
      <LegalSection heading="3. Erhebung und Speicherung personenbezogener Daten">
        <p>
          Beim Besuch unserer Website werden automatisch Informationen durch den Webserver
          erfasst. Hierzu gehören insbesondere:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>Browsertyp</li>
          <li>Betriebssystem</li>
          <li>Referrer-URL</li>
          <li>aufgerufene Seiten</li>
        </ul>
        <p>Diese Daten dienen ausschließlich der technischen Bereitstellung und Sicherheit der Website.</p>
        <p>Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.</p>
      </LegalSection>
      <LegalSection heading="4. Kontaktaufnahme">
        <p>
          Wenn Sie uns per Kontaktformular oder E-Mail kontaktieren, speichern wir Ihre Angaben
          zur Bearbeitung Ihrer Anfrage.
        </p>
        <p>Verarbeitet werden insbesondere:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Name</li>
          <li>E-Mail-Adresse</li>
          <li>Telefonnummer (optional)</li>
          <li>Nachricht</li>
        </ul>
        <p>Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.</p>
      </LegalSection>
      <LegalSection heading="5. Hosting">
        <p>Unsere Website wird bei einem externen Hosting-Anbieter betrieben.</p>
        <p>Dabei werden personenbezogene Daten auf den Servern des Hosters verarbeitet.</p>
        <p>Mit dem Hosting-Anbieter besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.</p>
      </LegalSection>
      <LegalSection heading="6. Cookies">
        <p>Unsere Website verwendet technisch notwendige Cookies.</p>
        <p>
          Soweit darüber hinaus Cookies zu Analyse- oder Marketingzwecken eingesetzt werden,
          erfolgt dies ausschließlich nach Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
        </p>
      </LegalSection>
      <LegalSection heading="7. Ihre Rechte">
        <p>Sie haben jederzeit das Recht auf</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Auskunft</li>
          <li>Berichtigung</li>
          <li>Löschung</li>
          <li>Einschränkung der Verarbeitung</li>
          <li>Datenübertragbarkeit</li>
          <li>Widerspruch gegen die Verarbeitung</li>
          <li>Widerruf einer erteilten Einwilligung</li>
        </ul>
        <p>Außerdem haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.</p>
      </LegalSection>
      <LegalSection heading="8. SSL-Verschlüsselung">
        <p>Unsere Website nutzt eine SSL- bzw. TLS-Verschlüsselung zum Schutz vertraulicher Inhalte.</p>
      </LegalSection>
      <LegalSection heading="9. Speicherdauer">
        <p>
          Personenbezogene Daten werden nur solange gespeichert, wie dies für den jeweiligen
          Zweck erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
        </p>
      </LegalSection>
      <LegalSection heading="10. Änderungen">
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte
          Rechtslagen oder technische Änderungen anzupassen.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
